<template>
  <div class="resume-container">
    <div class="resume-item" v-for="item in resume">

      <h3>
        {{ item.title }}
        <span class="period">
          {{ item.started }} - {{ item.ended }}
        </span>
      </h3>
      <h4>
        {{ item.company }}
        <span>
          {{ item.companyDescription }}
        </span>

      </h4>

      <p v-html="item.description"></p>
    </div>
  </div>

</template>

<script>
const resume = [
  {
    "company": "Fueled",
    "title": "Director of backend & blockchain",
    "started": "2015",
    "ended": "Present",
    "description": `
      <ul>
        <li>Leading a team of backend engineers and smart contract developers</li>
        <li>Architecting and strategizing application infrastructure with clients</li>
        <li>Providing reccomendations through Application Designs around code organization and service deployment</li>
        <li>Building applications in Python and Nodejs, inside the team created experimentations with Elixir and Golang</li>
        <li>Highly involved in development of the frontend web team and setting standards inside the team</li>
        <li>Great experience in working with financial systems in the Fintech industry</li>
        <li>Worked heavily with third party integrations such as Stripe, Twilio, Facebook, Twitter and many more</li>
        <li>Experience in messaging protocols; Http(s), Websockets, SOAP and Redis PubSub</li>
        <li>Co created infrastructure and deployment scripts with Terraform and Ansible for setting up new infrastructure quickly </li>
        <li>Most familiar with AWS services, besides that also experience in working with Heroku, Netlify and Firebase</li>
        <li>Recently blockchain was introduced as a new service, with my years of experience in the space took up the responsibility for internal research and building a new team</li>
      </ul>
    `,
    "companyDescription": "Award winning product agency"
  },
  {
    "title": "Backend Engineer",
    "started": "2014",
    "ended": "2015",
    "description": `
      <ul>
        <li>Moved from frontend to backend engineer as there was a big need, used my previous PHP experience and started to learn Python & NodeJS</li>
        <li>Worked on projects across many fields and types of integration, most significant working on projects like Matador and Youhue</li>
        <li>Contributed to internal standards, creating new processes to optimize client project flow</li>
        <li>Communicated with clients on project to deliver status updates and advice</li>
      </ul>
    `,
  },
  {
    "company": "Glem",
    "title": "Co Founder & CTO",
    "companyDescription": "Software for small busisness owners",
    "started": "2015",
    "ended": "Present",
    "description": `
      <ul>
        <li>Created a suite of payment & reservation systems for small businesses</li>
        <li>The systems handles mostly escrow payments between provider and customer, according to their reservations</li>
        <li>Building out frontend applications for multiple niches around barbershops, workshop owners and jumping halls in the Dutch market</li>
        <li>Mostly worked with Python for payment backend, all other niche "backends" are powered by Firebase for better collaboration with frontend team</li>
      </ul>
    `
  },
  {
    "company": "Glemma",
    "title": "Co Founder",
    "started": "2010",
    "ended": "2015",
    "companyDescription": "Small agency for web development",
    "description": `
      <ul>
        <li>Started agency with a good friend of mine in college</li>
        <li>Building pre-wordpress-era CMS websites with our own CMS called Kiddo, written in PHP</li>
        <li>Created DBAL, ORM and templating functionality for integrating custom modules for clients</li>
        <li>Project examples are http://ecnc.org, http://deblikkenemmer.nl, http://eoibisolatie.nl and http://ventilatieland.nl </li>
        <li>Glemma taught me to work with Magento, CodeIgniter, Zend Framework, Laravel and Wordpress</li>
        <li>Great demand created demand for freelancers to join organization, we hired several companies for maintenance and development</li>
        <li>Worked on-site for more specific software development such as Real Estate Management software and a FIFA World Cup Poll Tournament application</li>

      </ul>
    `,
  },
  {
    "company": "Sendcloud",
    "title": "Co founder & CTO",
    "started": "2011",
    "ended": "2013",
    "description": `
      <ul>
        <li>Created the whole application from the start, mostly working individually</li>
        <li>Increased my PHP and CodeIgniter knowledge</li>
        <li>Built out both backend and frontend applications, touching the whole spectrum of the project development</li>
        <li>Created packing slip module integrations in Magento, Woocommerce, Prestashop and Shopify</li>
        <li>Integrated Python driven hardware for printing out shipping labels</li>
        <li>Working together with developers overseas</li>
        <li>Left due to persisting urge to work overseas, company is now worth over 5 million euros (#shamelessplug)</li>
      </ul>
    `,
    "companyDescription": "Award winning product agency"
  }
]

export default {
  data: () => ({
    resume
  })
}
</script>

<style>
.resume-container h1,
.resume-container h2,
.resume-container h3,
.resume-container h4,
.resume-container h5 {
  margin: 0px;
  padding: 0px;
  font-family: Courier New;
}

.resume-container .resume-item {
  margin-bottom: 25px;
}

.resume-container ul {
  margin: 0px;
  padding: 3px;
}

.resume-container ul li {
  padding-bottom: 3px;
}

.resume-container h3 {
  font-size: 23px;
  margin-bottom: 0px;
}
.resume-container h3 span, .resume-container h4 span {
  font-weight: normal;
  font-size: 13px;
}
.resume-container h4 {
  font-size: 17px;
  margin-top: 5px;
}

.resume-container h5 {
  font-size: 17px;
}

.resume-container p {
  font-size: 12px;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// Resume.vue?120be17f